<div class="credits-card">
  <div class="credits-header">
    <div class="credits-label">
      <span class="credits-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
          <circle cx="8" cy="8" r="6" />
          <path d="M18.09 10.37A6 6 0 1 1 10.34 18" />
          <path d="M7 6h1v4" />
          <path d="m16.71 13.88.7.71-2.82 2.82" />
        </svg>
      </span>

      <!-- Change label based on mobile state -->
      <span class="label">{{ "topNav.yourCredits" | translate }}</span>
    </div>

    <!-- Hide credits count in mobile -->
    @if (!isMobile()) {
      <div class="credits-count">
        <span class="current">
          <span *ngIf="currentCredit() > 9999">Onbeperkt</span>
          <span *ngIf="currentCredit() < 9999">{{ currentCredit() }}</span>
        </span>
        <ng-container *ngIf="currentCredit() < 9999">
          <span class="arrow" *ngIf="willUse()">→</span>
          <span class="future" *ngIf="willUse()">{{ currentCredit() - (willUse() ?? 0) }}</span>
        </ng-container>
      </div>
    }
  </div>

  <div class="credits-progress" *ngIf="showProgress()">
    <div class="progress-bar-background">
      <div class="progress-bar-fill" width="progressWidth()"></div>
    </div>
  </div>
</div>
